// extracted by mini-css-extract-plugin
export var border = "_1h-7";
export var brand = "_1h-r";
export var button = "_1h-j";
export var center = "_1h-9";
export var centered = "_1h-5";
export var closeButton = "_1h-b";
export var disabledWrapper = "_1h-k";
export var error = "_1h-n";
export var extraLarge = "_1h-4";
export var extraSmall = "_1h-1";
export var fill = "_1h-g";
export var footer = "_1h-f";
export var footerAction = "_1h-h";
export var footerButtons = "_1h-i";
export var header = "_1h-6";
export var icon = "_1h-m";
export var info = "_1h-q";
export var inline = "_1h-8";
export var large = "_1h-3";
export var main = "_1h-c";
export var modal = "_1h-0";
export var neutral = "_1h-s";
export var noPadding = "_1h-e";
export var none = "_1h-t";
export var scrollable = "_1h-d";
export var small = "_1h-2";
export var success = "_1h-p";
export var tight = "_1h-l";
export var titleIcon = "_1h-a";
export var warn = "_1h-o";